export default [
    {
        path: '/website/categories',
        props: true,
        component: () => import('@/views/WebsiteCategory'),
    },
];
